
(function () {
  function getTrendingRoot() {
    return document.getElementById("goldenHomeTrendingTabs");
  }

  function getTrack(root) {
    if (!root) return null;
    return root.querySelector(".ghTrendTrack") ||
      root.querySelector("[data-gh-trend-track]") ||
      root.querySelector(".ghProductsTrack") ||
      root.querySelector(".ghSliderTrack") ||
      root.querySelector("[class*='Track']");
  }

  function getCards(track) {
    if (!track) return [];
    var cards = Array.prototype.slice.call(track.querySelectorAll(".ghProductCard"));
    if (!cards.length) {
      cards = Array.prototype.slice.call(track.children).filter(function (child) {
        return child && child.nodeType === 1;
      });
    }
    return cards;
  }

  function getCardStep(track) {
    var cards = getCards(track);
    if (!cards.length) return Math.max(280, Math.round(track.clientWidth * 0.85));

    var first = cards[0];
    var second = cards[1];
    var firstRect = first.getBoundingClientRect();

    if (second) {
      var secondRect = second.getBoundingClientRect();
      var distance = Math.abs(secondRect.left - firstRect.left);
      if (distance > 20) return distance;
    }

    var style = window.getComputedStyle(track);
    var gap = parseFloat(style.columnGap || style.gap || "0") || 0;
    return firstRect.width + gap;
  }

  function scrollTrack(track, direction) {
    if (!track) return;

    track.style.transform = "none";
    track.style.scrollBehavior = "smooth";

    var step = getCardStep(track);
    var max = track.scrollWidth - track.clientWidth;
    var next = track.scrollLeft + (direction * step);

    if (next > max - 4) next = max;
    if (next < 4) next = 0;

    track.scrollTo({
      left: next,
      behavior: "smooth"
    });
  }

  function isNextButton(button) {
    var text = (button.textContent || "").trim().toLowerCase();
    var aria = (button.getAttribute("aria-label") || "").toLowerCase();
    var cls = (button.className || "").toString().toLowerCase();
    var data = (button.getAttribute("data-direction") || button.getAttribute("data-gh-direction") || "").toLowerCase();

    return aria.indexOf("next") > -1 ||
      aria.indexOf("right") > -1 ||
      text === "›" ||
      text === ">" ||
      text.indexOf("next") > -1 ||
      cls.indexOf("next") > -1 ||
      cls.indexOf("right") > -1 ||
      data === "next" ||
      data === "right" ||
      data === "1";
  }

  function isPrevButton(button) {
    var text = (button.textContent || "").trim().toLowerCase();
    var aria = (button.getAttribute("aria-label") || "").toLowerCase();
    var cls = (button.className || "").toString().toLowerCase();
    var data = (button.getAttribute("data-direction") || button.getAttribute("data-gh-direction") || "").toLowerCase();

    return aria.indexOf("previous") > -1 ||
      aria.indexOf("prev") > -1 ||
      aria.indexOf("left") > -1 ||
      text === "‹" ||
      text === "<" ||
      text.indexOf("prev") > -1 ||
      cls.indexOf("prev") > -1 ||
      cls.indexOf("left") > -1 ||
      data === "prev" ||
      data === "previous" ||
      data === "left" ||
      data === "-1";
  }

  function bindTrendingSlider() {
    var root = getTrendingRoot();
    var track = getTrack(root);
    if (!root || !track) return;

    track.style.overflowX = "auto";
    track.style.scrollBehavior = "smooth";
    track.style.transform = "none";

    var buttons = Array.prototype.slice.call(root.querySelectorAll("button, [role='button'], .ghTrendArrow, .ghTrendNav, [class*='Arrow'], [class*='arrow']"));

    buttons.forEach(function (button) {
      if (button.getAttribute("data-gh-picks-slider-fixed") === "true") return;

      var next = isNextButton(button);
      var prev = isPrevButton(button);

      if (!next && !prev) return;

      button.setAttribute("data-gh-picks-slider-fixed", "true");

      button.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();

        var currentRoot = getTrendingRoot();
        var currentTrack = getTrack(currentRoot);
        scrollTrack(currentTrack, next ? 1 : -1);
      }, true);
    });

    // If no buttons were detected, support common left/right buttons outside root but close to section.
    document.querySelectorAll("button").forEach(function (button) {
      if (button.getAttribute("data-gh-picks-global-fixed") === "true") return;

      var box = button.closest("#goldenHomeTrendingTabs");
      if (box) return;

      var aria = (button.getAttribute("aria-label") || "").toLowerCase();
      var cls = (button.className || "").toString().toLowerCase();

      var likelyTrending = cls.indexOf("trend") > -1 || cls.indexOf("product") > -1 || cls.indexOf("slider") > -1 || cls.indexOf("carousel") > -1;
      var next = likelyTrending && (aria.indexOf("next") > -1 || cls.indexOf("next") > -1 || cls.indexOf("right") > -1);
      var prev = likelyTrending && (aria.indexOf("prev") > -1 || aria.indexOf("previous") > -1 || cls.indexOf("prev") > -1 || cls.indexOf("left") > -1);

      if (!next && !prev) return;

      button.setAttribute("data-gh-picks-global-fixed", "true");
      button.addEventListener("click", function (event) {
        var currentRoot = getTrendingRoot();
        var currentTrack = getTrack(currentRoot);
        if (!currentTrack) return;
        event.preventDefault();
        event.stopPropagation();
        scrollTrack(currentTrack, next ? 1 : -1);
      }, true);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bindTrendingSlider);
  } else {
    bindTrendingSlider();
  }

  window.addEventListener("resize", bindTrendingSlider);
  document.addEventListener("shopify:section:load", bindTrendingSlider);
})();
